export default [
	{
		title: "课程详情",
		name: "freeCourse/courseDetail",
		alias: "/courseDetail"
	},
	{
		title: "好友点赞，免费听课",
		name: "freeCourse/freeCourseIndex"
	},
	{
		title: "鸭题库",
		name: "freeCourse/login"
	},
	{
		title: "笔试查分了！2019年要拿教师资格证，这个你一定不要错过",
		name: "teacherNav/teacherNav"
	},
	{
		title: "雪狐狸",
		name: "xuehuliNurse/subjectListPage"
	},
	{
		title: "雪狐狸",
		name: "xuehuliNurse/subjectContent"
	},
	{
		title: "活动海报",
		name: "posterPage/posterPage"
	},
	{
		title: "超级口碑",
		name: "fireControl/superBrand0427"
	},
	{
		title: "超级口碑",
		name: "fireControl2/superBrand0427"
	},
	// {
	// 	title: '训练营',
	// 	name: 'train',
	// 	child: 'train',
	// 	redirect: 'activity/train/trainStudy'
	// },
	// {
	// 	title: '个人中心',
	// 	name: 'trainManage',
	// 	child: 'trainManage',
	// 	redirect: 'activity/trainManage/manage'
	// },
	// {
	// 	title: '习题',
	// 	name: 'topic',
	// },
	// {
	// 	title: '视频解析',
	// 	name: 'train/explain'
	// },

	// {
	// 	title: '活动',
	// 	name: 'train/trainGroup',
	// 	alias: '/trainGroup'
	// },
	{
		title: "分享返现",
		name: "redPacket",
		alias: "/redPacket/index"
	},
	{
		title: "习题",
		name: "examination"
	},
	{
		title: "习题视频",
		name: "examination/video"
	},
	{
		title: "分享",
		name: "examination/share"
	},
	{
		title: "习题",
		name: "exam"
	},
	{
		title: "选择科目",
		name: "exam/select"
	},
	{
		title: "课程详情",
		name: "shopCourse/index",
		alias: "/shopCourse"
	},
	{
		title: "确认订单",
		name: "shopCourse/ShopOrderPay/index",
		alias: "/ShopOrderPay"
	},
	{
		title: "支付详情",
		name: "shopCourse/ShopOrderPay/success",
		alias: "/PaySuccess"
	},
	{
		title: "订单详情",
		name: "shopCourse/ShopOrderPay/orderExpress",
		alias: "/PayDetail"
	},
	{
		title: "分享返现",
		name: "shopCourse/redPacket/index"
	},
	{
		title: "感言",
		name: "atc",
		child: "atc"
	},
	{
		title: "考前密卷",
		name: "accounting",
		child: "accounting"
	},
	{
		title: "密训押题班",
		alias: "/mixun",
		name: "mixun/index"
	},
	{
		title: "分享返现",
		name: "mixun/redPacket/index"
	},
	{
		title: "2019年执业药师高端取证班，考前通关捷径",
		name: "protectActivity/protectActivity"
	},
	{
		title: "免费领取！2019全新教师资格考试资料包",
		name: "basicsPage/basicsPage"
	},
	{
		title: "学员有话说",
		name: "basicsPage/talk"
	},
	{
		title: "寻找72分幸运儿",
		name: "basicsPage/find"
	},
	{
		title: "执业药师历年真题学霸笔记5年高频考题冲刺密训卷核心考点",
		name: "basicsPage/pharmacist"
	},
	{
		title: "2019最新课程—官方旗舰班，助你无忧取证",
		name: "basicsPage/pharmacist181204"
	},
	{
		title: "名额有限 | 2019执业药师专用书《5年高频考题》免费赠送",
		name: "basicsPage/pharmacist1812043"
	},
	{
		title: "手慢无！免费送2019药考最新教材—学霸笔记",
		name: "basicsPage/pharmacist1812042"
	},
	{
		title: "2019教师资格七天密训计划",
		name: "basicsPage/teacher"
	},
	{
		title: "免费领取！2019全新教师资格考试资料包",
		name: "basicsPage/code"
	},
	{
		title: "福利！2019初级会计最新10G资料包，你领了吗？",
		name: "basicsPage/accounting/20181211"
	},
	{
		title: "考生有话说",
		name: "basicsPage/accounting/20190604"
	},
	{
		title: "2019护士、护师考生必备【一对一通关辅导计划】免费领！",
		name: "basicsPage/basicsPage2"
	},
	{
		title: "药考尊享大礼包，免费送",
		name: "basicsPage/basicsPage3"
	},
	{
		title: "【重磅推荐】2019护考一次取证必备课程",
		name: "basicsPage/nurse181121"
	},
	{
		title: "2019护士『考试大纲』电子版下载",
		name: "basicsPage/nurse181122"
	},
	{
		title: "2019初级会计职称考试",
		name: "basicsPage/teacher181123"
	},
	{
		title: "【免费领】2019护考取证大礼包！100万考生疯狂抢！",
		name: "basicsPage/nurse181126"
	},
	{
		title: "选择科目",
		name: "realProblem/realProblemIndex"
	},
	{
		title: "2018经济师考前必做200题！",
		name: "realProblem/realProblem"
	},
	{
		title: "助力活动",
		name: "boostByFriend"
	},
	{
		title: "助力活动",
		name: "boostByFriend/boost"
	},
	{
		title: "用户活动",
		name: "boostByFriend/poster"
	},
	{
		title: "助力成功",
		name: "boostByFriend/result"
	},
	{
		title: "助力排行榜",
		name: "boostByFriend/rank"
	},
	{
		title: "助力活动",
		name: "fireBoost"
	},
	{
		title: "用户活动",
		name: "fireBoost/poster"
	},
	{
		title: "助力成功",
		name: "fireBoost/result"
	},
	{
		title: "鸭题库5天特训营",
		name: "sevenDays/sevenDays"
	},
	{
		title: "免费包邮送！参加特训计划0元可享受药考大礼包",
		name: "pharmacist/pharmacist1213"
	},
	{
		title: "",
		name: "activityConfigPage/activityConfigPage"
	},
	{
		title: "",
		name: "allActivity/allActivity"
	},

	//每日一练习
	{
		title: "每日一练",
		name: "daily/index"
	},
	{
		title: "开始练习",
		name: "daily/topic"
	},
	{
		title: "提交试卷",
		name: "daily/submit"
	},
	{
		title: "登录",
		name: "daily/login"
	},
	{
		title: "测试",
		name: "test",
		child: "test"
	},
	{
		title: "天猫活动赠品",
		name: "tmallActivity"
	},
	{
		title: "初级会计考试精美成绩单",
		name: "2019AccountReport/index"
	},
	{
		title: "生成成绩单",
		name: "2019AccountReport/canvas"
	},
	{
		title: "老师号二维码",
		name: "posterPage/teacherCode"
	},
	{
		title: "晒图行动",
		name: "poImg/index"
	},
	{
		title: "榜单排名",
		name: "poImg/rank"
	},
	{
		title: "上传晒图",
		name: "poImg/upload"
	},
	{
		title: "我的晒图",
		name: "poImg/user"
	},
	{
		title: "活动详情",
		name: "poImg/activityDetail"
	},
	{
		title: "护理预约查成绩",
		name: "transcript/poster"
	},
	{
		title: "护理成绩查询",
		name: "transcript/inquire"
	},
	{
		title: "史上最低价  决战双12",
		name: "cashCoupon"
	},
	{
		title: "史上最低价  决战双12",
		name: "cashCoupon/physicians"
	},
	{
		title: "点击领取，代金券抵扣600抢购《消防课程》",
		name: "cashCoupon/fireBasicCourse"
	},
	{
		title: "大额优惠券，不要错过！",
		name: "cashCoupon/fire"
	},
	{
		title: "报考指南",
		name: "guidePage"
	},
	{
		title: "2019执业药师官方报考指南",
		name: "guidePage/home",
		params: "home"
	},
	{
		title: "报考指南",
		name: "guidePage/fireControl"
	},
	{
		title: "2020消防工程师官方报考指南",
		name: "guidePage/fireControl/home"
	},
	{
		title: "千课教育",
		name: "guidePage/xuehuli2021"
	},
	{
		title: "千课教育",
		name: "guidePage/xuehuli2021/home"
	},
	{
		title: "2019一级消防考试官方报考指南",
		name: "fireGuide/home"
	},
	{
		title: "2019一级消防考试官方报考指南",
		name: "fireGuide"
	},
	{
		title: "2021药学职称最新版报考指南",
		name: "guidePage/pharmacist"
	},
	{
		title: "推荐“考医师”好友赚现金大奖",
		name: "pharmacistShare/poster"
	},
	{
		title: "推荐“考医师”好友赚现金大奖",
		name: "pharmacistShare/wallet"
	},
	{
		title: "推荐“考医师”好友赚现金大奖",
		name: "pharmacistShare/rule"
	},
	{
		title: "推荐“考医师”好友赚现金大奖",
		name: "pharmacistShare/withdrawLog"
	},
	{
		title: "推荐“考医师”好友赚现金大奖",
		name: "pharmacistShare/receive"
	},
	{
		title: "领免费会计教材赚现金奖励",
		name: "accountingRecommend/index"
	},
	{
		title: "领免费会计教材赚现金奖励",
		name: "accountingRecommend/wallet"
	},
	{
		title: "领免费会计教材赚现金奖励",
		name: "accountingRecommend/withdrawLog"
	},
	{
		title: "领免费会计教材赚现金奖励",
		name: "accountingRecommend/poster"
	},
	{
		title: "一路陪伴，我们共同取证",
		name: "noteCourse/index"
	},
	{
		title: "高效特训班",
		params: "201908FireControlCourse",
		name: "201908FireControlCourse/index",
		grade: 1
	},
	{
		title: "雪狐狸 | 校园大使申请",
		name: "bestAmbassador/index"
	},
	{
		title: "奖品介绍",
		name: "bestAmbassador/prize"
	},
	{
		title: "2019医考真题对答案",
		name: "pharmacist/pharmacistQa"
	},
	{
		title: "2019医考真题对答案",
		name: "pharmacist/pharmacistDetail"
	},
	{
		title: "视频播放题",
		name: "scanCodeExercises/index"
	},
	{
		title: "最美卫校评选",
		name: "schoolVote/index"
	},
	{
		title: "最美卫校评选",
		name: "schoolVote/detail"
	},
	{
		title: "奖品介绍",
		name: "schoolVote/prize"
	},

	// V2
	{
		title: "最美卫校评选",
		name: "schoolVoteV2/index"
	},
	{
		title: "最美卫校评选",
		name: "schoolVoteV2/detail"
	},
	{
		title: "奖品介绍",
		name: "schoolVoteV2/prize"
	},
	{
		title: "拉票助力排行",
		name: "schoolVoteV2/rank"
	},
	{
		title: "鸭题库——押题密卷参考答案",
		name: "pharmacist/qaExplain/index"
	},
	{
		title: "雪狐狸——押题密卷参考答案",
		name: "nursing/qaExplain/index"
	},
	{
		title: "鸭题库——答案解析",
		name: "pharmacist/qaExplain/list"
	},
	{
		title: "鸭题库——答案解析",
		name: "pharmacist/qaExplain/detail"
	},
	{
		title: "更多护考好书",
		name: "scanCodeExercises/goods"
	},
	{
		title: "冲刺特训班",
		params: "201909FireControlCourse",
		name: "201909FireControlCourse/index",
		grade: 1
	},
	{
		title: "解密如何通过2019年消防考试",
		name: "201909FireControlCourse/examPaper"
	},
	{
		title: "2019中级会计真题对答案",
		name: "accounting/accountingQa"
	},
	{
		title: "2019中级会计真题对答案",
		name: "accounting/accountingDetail"
	},
	{
		title: "2019健康管理师真题对答案",
		name: "healthManager/healthManagerQa"
	},
	{
		title: "2019健康管理师真题对答案",
		name: "healthManager/healthManagerDetail"
	},
	//消防-押题密卷参考答
	{
		title: "鸭题库——押题密卷参考答案",
		name: "fireControl/qaExplain/index"
	},
	{
		title: "鸭题库——答案解析",
		name: "fireControl/qaExplain/list"
	},
	{
		title: "鸭题库——答案解析",
		name: "fireControl/qaExplain/detail"
	},
	//消防考试-历年真题答案解析
	{
		title: "鸭题库——押题密卷参考答案",
		name: "fireControl2/qaExplain/index"
	},
	{
		title: "鸭题库——答案解析",
		name: "fireControl2/qaExplain/list"
	},
	{
		title: "鸭题库——答案解析",
		name: "fireControl2/qaExplain/detail"
	},
	// {
	// 	title: '中级会计必考点速记',
	// 	name: 'answerFile/answer'
	// },
	// {
	// 	title: '今日考题-2018年中级会计考题（原题重现）',
	// 	name: 'subjectCollect/subjectCollect'
	// },
	// {
	// 	title: '今日考题-2018年中级会计考题（原题重现）',
	// 	name: 'subjectCollect/index'
	// },
	// {
	// 	title: '今日考题-2018年中级会计考题（原题重现）',
	// 	name: 'subjectCollect/upSubject'
	// },
	// {dfdfddfgdfs00dc00xc  dfdfdfdsgfxxzz    ``
	// 	title: '免费领取！2018教师资格考试《视频课程+名师讲义+10G资料包》',
	// 	name: 'receive/receive'
	// },
	// {
	// 	title: '免费领取！2018教师资格考试《视频课程+名师讲义+10G资料包》',
	// 	name: 'receive/additionReceive'
	// }
	// {
	// 	title: '直播间',
	// 	name: 'lecturerLive/lecturerLive'
	// }

	// 最美卫校
	{
		title: "登记信息",
		name: "bestColleage/index"
	},
	{
		title: "登记信息",
		name: "bestColleage/indexRemind"
	},
	{
		title: "我的奖品",
		name: "bestColleage/registerComplete"
	},
	{
		title: "我的奖品",
		name: "bestColleage/registerRemindComplete"
	},
	//会计活动2.0
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite2.0/withdrawLog"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite2.0/index"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite2.0/withdraw"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite2.0/wallet",
		params: "accounting/recommend/invite2.0/wallet/:type?"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite2.0/rank"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite2.0/withdraw"
	},
	{
		title: "免费领2020初/中级会计考试图书",
		name: "accounting/recommend/shop/index"
	},
	{
		title: "诸葛锦囊",
		name: "accounting/recommend/shop/newActive"
	},
	{
		title: "一元拼团",
		name: "accounting/recommend/shop/oneGou"
	},
	// 购买页面
	{
		title: "免费领2020初/中级会计考试图书",
		params: "accountingShopBuy",
		name: "accounting/recommend/shop/buy",
		grade: 1
	},
	//物流页面
	{
		title: "免费领2020初/中级会计考试图书",
		name: "accounting/recommend/shop/logisticsInformation"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite2.0/poster"
	},
	{
		title: "鸭题库",
		name: "poster/index"
	},
	{
		title: "药考大数据",
		name: "posterData/index"
	},
	{
		title: "执业药师15天冲刺学习报告",
		name: "studyReport/consultation/consultation"
	},
	{
		title: "执业药师15天冲刺学习报告",
		name: "studyReport/consultation/consultation2"
	},

	{
		title: "执业药师15天冲刺学习报告",
		name: "studyReport/consultation/consultation3"
	},
	{
		title: "分享",
		name: "studyReport/consultation/sharePage"
	},
	{
		title: "考点错题",
		name: "studyReport/errorPoint/index"
	},
	{
		title: "考点错题",
		name: "studyReport/errorPoint/index2"
	},
	{
		title: "一元抢购",
		name: "oneBuy/index"
	},
	// 购买页面
	{
		title: "一元抢购",
		params: "oneBuyPay",
		name: "oneBuy/buy",
		grade: 1
	},
	//详情页面
	{
		title: "一元抢购",
		name: "oneBuy/logisticsInformation"
	},

	{
		title: "邀好友领初/中级会级图书得5000现金",
		name: "accounting/recommend/invite/withdrawLog"
	},
	{
		title: "限量抢2020会计图书",
		name: "accounting/recommend/invite/subjectIndex"
	},
	{
		title: "邀好友领初/中级会级图书得5000现金",
		name: "accounting/recommend/invite/index"
	},
	{
		title: "领免费会计教材赚现金奖励",
		name: "accounting/recommend/shop/indexMiddleLevel"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite/withdraw"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite/wallet",
		params: "accounting/recommend/invite/wallet/:type?"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite/rank"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite/withdraw"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite/poster"
	},
	//3.0
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite3.0/rank"
	},
	//医师
	{
		title: "鸭题库——通关密押答案解析",
		name: "teacher/qaExplain/index"
	},
	{
		title: "鸭题库——通关密押答案解析",
		name: "teacher/qaExplain/list"
	},
	{
		title: "鸭题库——通关密押答案解析",
		name: "teacher/qaExplain/detail"
	},

	//会计活动3.0
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite4.0/withdrawLog"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite4.0/index"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite4.0/withdraw"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite4.0/wallet",
		params: "accounting/recommend/invite4.0/wallet/:type?"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite4.0/rank"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite4.0/withdraw"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite4.0/poster"
	},
	{
		title: "押题对照",
		name: "contrast/index"
	},
	{
		title: "押题对照",
		name: "contrast2/index"
	},
	{
		title: "考后对答案",
		name: "contrast3/index"
	},
	{
		title: "考后对答案",
		name: "contrast4/index"
	},
	{
		title: "双十一会场",
		name: "doubleEleven/index"
	},

	//会计活动4.0
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite5.0/withdrawLog"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite5.0/withdraw"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite5.0/wallet",
		params: "accounting/recommend/invite5.0/wallet/:type?"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite5.0/rank"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite5.0/withdraw"
	},
	{
		title: "邀好友领初会图书得5000现金",
		name: "accounting/recommend/invite5.0/poster"
	},

	//会计活动5.0
	{
		title: "邀好友领初/中级会级图书得5000现金",
		name: "accounting/recommend/invite6.0/withdrawLog"
	},
	{
		title: "邀好友领初/中级会级图书得5000现金",
		name: "accounting/recommend/invite6.0/withdraw"
	},
	{
		title: "邀好友领初/中级会级图书得5000现金",
		name: "accounting/recommend/invite6.0/wallet",
		params: "accounting/recommend/invite6.0/wallet/:type?"
	},
	{
		title: "邀好友领初/中级会级图书得5000现金",
		name: "accounting/recommend/invite6.0/rank"
	},
	{
		title: "邀好友领初/中级会级图书得5000现金",
		name: "accounting/recommend/invite6.0/withdraw"
	},
	{
		title: "邀好友领初/中级会级图书得5000现金",
		name: "accounting/recommend/invite6.0/poster"
	},

	//会计活动6.0
	{
		title: "邀好友领初/中级会级图书得5000现金",
		name: "accounting/recommend/invite7.0/withdrawLog"
	},
	{
		title: "邀好友领初/中级会级图书得5000现金",
		name: "accounting/recommend/invite7.0/withdraw"
	},
	{
		title: "邀好友领初/中级会级图书得5000现金",
		name: "accounting/recommend/invite7.0/wallet",
		params: "accounting/recommend/invite7.0/wallet/:type?"
	},
	{
		title: "邀好友领初/中级会级图书得5000现金",
		name: "accounting/recommend/invite7.0/rank"
	},
	{
		title: "邀好友领初/中级会级图书得5000现金",
		name: "accounting/recommend/invite7.0/withdraw"
	},
	{
		title: "邀好友领初/中级会级图书得5000现金",
		name: "accounting/recommend/invite7.0/poster"
	},

	//推荐有奖活动配置页
	{
		title: "邀好友领图书得现金",
		name: "allRecommend/invite/index"
	},
	{
		title: "邀好友领图书得现金",
		name: "allRecommend/invite/withdrawLog"
	},
	{
		title: "邀好友领图书得现金",
		name: "allRecommend/invite/withdraw"
	},
	{
		title: "邀好友领图书得现金",
		name: "allRecommend/invite/wallet",
		params: "allRecommend/invite/wallet/:type?"
	},
	{
		title: "邀好友领图书得现金",
		name: "allRecommend/invite/rank"
	},
	{
		title: "邀好友领图书得现金",
		name: "allRecommend/invite/withdraw"
	},
	{
		title: "邀好友领图书得现金",
		name: "allRecommend/invite/poster"
	},

	{
		title: "千课教育",
		name: "allRecommend/shop/index"
	},
	// 购买页面
	{
		title: "千课教育",
		params: "allRecommendShopBuy",
		name: "allRecommend/shop/buy",
		grade: 1
	},
	// 选择科目页面
	{
		title: "千课教育",
		name: "allRecommend/shop/subjectIndex"
	},
	//物流页面
	{
		title: "千课教育",
		name: "allRecommend/shop/logisticsInformation"
	},
	//物流页面v2
	{
		title: "千课教育",
		name: "allRecommend/shop/logisticsInformation",
		params: "activity/allRecommend/shop/logisticsInformationV2",
		grade: 4
	},
	//物流页面v3
	{
		title: "千课教育",
		name: "allRecommend/shop/logisticsInformation",
		params: "activity/allRecommend/shop/logisticsInformationV3/:type?",
		grade: 4
	},
	//物流页面v3
	{
		title: "千课教育",
		name: "allRecommend/shop/newLogistics",
		params: "activity/allRecommend/shop/logisticsInformationV4",
		grade: 4
	},
	// 药考专用
	{
		title: "【免费领书】2020药考大礼包",
		name: "allRecommend/shop/pharmacySubject"
	},
	{
		title: "免费领 最新出版消考《口碑习题集》",
		name: "allRecommend/shop/subjectOption"
	},
	{
		title: "优学电子科技应用下载",
		name: "appMap/index"
	},
	{
		title: "教师面试真题",
		name: "teacher/interviewExam/selectSubject"
	},
	{
		title: "教师面试真题",
		name: "teacher/interviewExam/selectSecondSubject"
	},
	{
		title: "教师面试真题",
		name: "teacher/interviewExam/qaList"
	},
	{
		title: "教师面试真题",
		name: "teacher/interviewExam/qaDetail"
	},

	/**
	 * 投放商品
	 */
	{
		title: "千课教育",
		name: "advertisingGoods/shop/index"
	},
	{
		title: "千课教育",
		params: "advertisingShopBuy",
		name: "advertisingGoods/shop/buy",
		grade: 1
	},
	{
		title: "千课教育",
		name: "advertisingGoods/shop/subjectIndex"
	},
	{
		title: "千课教育",
		name: "advertisingGoods/shop/logisticsInformation"
	},
	{
		title: "【免费领书】2020药考大礼包",
		name: "advertisingGoods/shop/pharmacySubject"
	},
	{
		title: "免费领 最新出版消考《口碑习题集》",
		name: "advertisingGoods/shop/subjectOption"
	}
];



// WEBPACK FOOTER //
// ./src/route/activityRoute.js